import React from 'react';

interface LinkProps {
  href?: string;
  text?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  icon?: React.ReactNode;
  className?: string;
  textWrapperClassName?: string;
  onClick?: (_: any) => void;
}

const Link: React.FC<LinkProps> = ({
  text,
  href,
  target,
  icon,
  className,
  textWrapperClassName,
  onClick,
}) => {
  return (
    <a
      href={href || '#'}
      className={className || ''}
      target={target}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick(e);
      }}
    >
      {icon && icon}
      {text && <span className={textWrapperClassName || ''}>{text}</span>}
    </a>
  );
};

export default Link;
